'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidFilm = function IoAndroidFilm(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.4 5h3.1v30h-3.1v-3.4h-3.1v3.4h-12.5v-3.4h-3.2v3.4h-3.1v-30h3.1v3.4h3.2v-3.4h12.5v3.4h3.1v-3.4z m-15.6 23.4v-3.4h-3.2v3.4h3.2z m0-6.8v-3.2h-3.2v3.2h3.2z m0-6.6v-3.4h-3.2v3.4h3.2z m15.6 13.4v-3.4h-3.1v3.4h3.1z m0-6.8v-3.2h-3.1v3.2h3.1z m0-6.6v-3.4h-3.1v3.4h3.1z' })
        )
    );
};

exports.default = IoAndroidFilm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-film.js
// module id = 1890
// module chunks = 0